class CurrencySwitcher {

  currencies = [
    {
      'iso_code': 'GBP',
      priceBands: [
        'band-b-gbp',
        'band-c-gbp',
        'band-d-gbp',
      ]
    },
    {
      'iso_code': 'EUR',
      priceBands: [
        'band-b-eur',
        'band-c-eur',
      ]
    },
    {
      'iso_code': 'USD',
      priceBands: [
        'band-b-usd',
        'band-d-usd',
      ]
    }
  ];

  constructor() {
    this.maybeSwitch();
  }

  async maybeSwitch() {
    const priceBand = await priceBands.getCurrentPriceBand();

    if (!priceBand) {
      return;
    }

    const priceBandCurrencyCode = this.getCurrencyCodeByPriceBand(priceBand);

    if (!priceBandCurrencyCode) {
      return;
    }

    if (priceBandCurrencyCode == Shopify.currency.active) {
      return;
    }

    this.switch(priceBandCurrencyCode);
  }

  getCurrencyCodeByPriceBand(priceBand) {
    const currency = this.currencies.find(
      (currency) => {
        return currency.priceBands.includes(priceBand)
      }
    );

    if (typeof currency == 'undefined') {
      return null;
    }

    return currency.iso_code;
  }

  async switch(currencyCode) {
    const countryToSwitchTo = await this.getCountryToSwitchTo(currencyCode);

    if (!countryToSwitchTo) {
      console.warn('No applicable countries found for currency: ' + currencyCode);
      return;
    }

    await fetch('/?country=' + countryToSwitchTo.iso_code);

    creodeShopifyCustomPrices.clearCache();

    let url = new URL(location.href);

    url.searchParams.delete('country');
    location.href = url.toString();
  }

  async getCountryToSwitchTo(currencyCode) {
    const applicableCountries = await countries.getByCurrency(currencyCode);

    if (applicableCountries.length == 0) {
      return null;
    }

    const geolocationCountryCode = await this.getGeolocationCountryCode();

    if (!geolocationCountryCode) {
      return this.decideDefaultCountryToSwitchTo(applicableCountries, currencyCode);
    }

    const country = applicableCountries.find(
      (country) => {
        return country.iso_code == geolocationCountryCode
      }
    );

    if (typeof country != 'undefined') {
      return country;
    }

    return this.decideDefaultCountryToSwitchTo(applicableCountries, currencyCode);
  }

  async getGeolocationCountryCode() {
    let response = null;

    try {
      response = await fetch('https://ipapi.co/json/');
    } catch (error) {
      console.warn('Error getting geolocation country code: ' + error.message);
      return null;
    }

    if (!response.ok) {
      return null;
    }

    const data = await response.json();

    return data.country_code;
  }

  decideDefaultCountryToSwitchTo(applicableCountries, currencyCode) {
    if ('USD' == currencyCode) {
      const usa = applicableCountries.find(
        (country) => {
          return country.iso_code == 'US'
        }
      );

      if (typeof usa != 'undefined') {
        return usa;
      }
    }

    return applicableCountries[0];
  }
}

(async () => {
  await new Promise(
    (resolve) => {
      const interval = setInterval(
        () => {
          if (typeof Shopify == 'undefined') {
            return;
          }

          if (typeof priceBands == 'undefined') {
            return;
          }

          if (typeof countries == 'undefined') {
            return;
          }

          if (typeof creodeShopifyCustomPrices == 'undefined') {
            return;
          }

          clearInterval(interval);
          resolve();
        },
        50
      );
    }
  );

  // Create global currencySwitcher instance now that creodeAjaxAPI is ready
  window.currencySwitcher = new CurrencySwitcher();
})();
